"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/upload/style/css");

var _upload = _interopRequireDefault(require("antd/es/upload"));

require("antd/es/radio/style/css");

var _radio = _interopRequireDefault(require("antd/es/radio"));

require("antd/es/date-picker/style/css");

var _datePicker = _interopRequireDefault(require("antd/es/date-picker"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/menu/style/css");

var _menu = _interopRequireDefault(require("antd/es/menu"));

require("antd/es/dropdown/style/css");

var _dropdown = _interopRequireDefault(require("antd/es/dropdown"));

require("antd/es/checkbox/style/css");

var _checkbox = _interopRequireDefault(require("antd/es/checkbox"));

require("antd/es/cascader/style/css");

var _cascader = _interopRequireDefault(require("antd/es/cascader"));

require("antd/es/alert/style/css");

var _alert = _interopRequireDefault(require("antd/es/alert"));

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

var _lodash = _interopRequireWildcard(require("lodash"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _uuid = _interopRequireDefault(require("uuid"));

var _forum = require("../../redux/forum/forum.types");

var _posts = require("../../redux/posts/posts.types");

var _api = _interopRequireDefault(require("../../redux/api"));

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

require("./forumPostCreationModal.scss");

var _moment = _interopRequireDefault(require("moment"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  TextArea
} = _input.default;
const {
  confirm
} = _modal.default;
const initialState = {
  selectedPost: undefined,
  selectedFlaggedPost: undefined,
  isEditing: false,
  newPostTitle: '',
  newPostBody: '',
  newPublishDate: (0, _moment.default)(),
  newPostPollOptions: [],
  addPostError: false,
  addPostErrorMessage: '',
  selectedArmIds: [],
  selectedTopicIdsMap: new Map(),
  fileList: [],
  postLinkType: 'none',
  previewImage: '',
  previewVisible: false,
  videoWebLink: '',
  image: undefined,
  selectedParticipantMap: new Map()
};

function selectedParticipantFilter(inputValue, path) {
  return path.some(option => option.label ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1 : false);
}

class ForumPostCreationModal extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;

    this.onRemove = file => {
      this.setState({
        fileList: []
      });
    };

    this.beforeUpload = file => {
      if (file.size > 50000) {
        _message2.default.error('Upload failed. File exceeds 50KB limit.');

        return false;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      return new Promise((resolve, reject) => {
        reader.onload = () => {
          if (reader.result) {
            this.setState({
              previewImage: reader.result
            });
            this.setState({
              image: file
            });
            this.setState({
              fileList: [{
                uid: '-1',
                name: 'name',
                status: 'done',
                url: reader.result
              }]
            });
            resolve(true);
          }

          resolve(false);
        };
      });
      return true;
    };

    this.handleOk = async () => {
      const {
        newPostTitle,
        newPostBody,
        newPublishDate,
        newPostPollOptions,
        selectedTopicIdsMap,
        selectedArmIds,
        postLinkType,
        image,
        videoWebLink,
        selectedParticipantMap
      } = this.state;
      const {
        savePost,
        clearPosts,
        resetRecentActivityPostIds,
        closeHandler,
        hasCareNavigatorRole
      } = this.props;
      this.setState({
        addPostError: false
      }); // Begin by checking that the form items have valid responses

      if ((0, _lodash.isEmpty)(selectedArmIds)) {
        this.setState({
          addPostError: true,
          addPostErrorMessage: 'Please select at least one study arm to post to'
        });
      } else if ((0, _lodash.isEmpty)(newPostTitle)) {
        this.setState({
          addPostError: true,
          addPostErrorMessage: 'Please enter a post title'
        });
      } else if ((0, _lodash.isEmpty)(newPostBody)) {
        this.setState({
          addPostError: true,
          addPostErrorMessage: 'Please enter a post body'
        });
      } else if ((0, _lodash.find)(newPostPollOptions, o => o.option.trim() === '')) {
        this.setState({
          addPostError: true,
          addPostErrorMessage: 'One of your options is empty'
        });
      } else if ((0, _lodash.isEmpty)(selectedTopicIdsMap)) {
        this.setState({
          addPostError: true,
          addPostErrorMessage: 'Please select a post topic'
        });
      } else {
        const {
          forums,
          pseudoParticipants
        } = this.props;
        const pseudoParticipantsGroupedByStudyArmId = (0, _lodash.groupBy)(pseudoParticipants, p => p.studyArmId); // Check that all the selected arms have a corresponding topic selected

        const currentForums = (0, _lodash.filter)(forums, f => _lodash.default.includes(selectedArmIds, f.studyArmId));

        if (selectedTopicIdsMap && selectedArmIds) {
          await Promise.all((0, _lodash.map)(selectedArmIds, async armId => {
            var _a, _b;

            const currentTopicCollectionId = (_a = currentForums.find(f => f.studyArmId === armId)) === null || _a === void 0 ? void 0 : _a.topicCollectionIds[0];
            const actualTopicCollectionIds = [...selectedTopicIdsMap.keys()]; // Compare the selected topicCollectionIds with the corresponding
            // study arm topic collection ids that have been selected.

            if (currentTopicCollectionId && actualTopicCollectionIds.indexOf(currentTopicCollectionId) === -1) {
              this.setState({
                addPostError: true,
                addPostErrorMessage: 'The number of topics selected doesn\'t match with the number of study arms selected.'
              });
            } else {
              // Create new post in all the selected arms
              const newPost = {
                title: newPostTitle,
                body: newPostBody,
                publishDate: newPublishDate
              };

              if (currentTopicCollectionId) {
                const currentForum = (0, _lodash.find)(currentForums, f => f.topicCollectionIds.includes(currentTopicCollectionId));
                const currentArmParticipantId = hasCareNavigatorRole || pseudoParticipantsGroupedByStudyArmId[armId].length > 1 ? selectedParticipantMap.get(currentForum.studyArmId.toString()) : (_b = (0, _lodash.find)(pseudoParticipants, p => p.studyArmId === (currentForum === null || currentForum === void 0 ? void 0 : currentForum.studyArmId) && p.type === 'PSEUDO PARTICIPANT')) === null || _b === void 0 ? void 0 : _b.id;

                if (!currentArmParticipantId) {
                  this.setState({
                    addPostError: true,
                    addPostErrorMessage: 'You must select a participant to post as'
                  });
                  return false;
                }

                if (postLinkType === 'poll') {
                  if (newPostPollOptions.length < 2) {
                    this.setState({
                      addPostError: true,
                      addPostErrorMessage: 'You must include at least two poll options'
                    });
                    return false;
                  }

                  Object.assign(newPost, {
                    poll: {
                      options: newPostPollOptions
                    }
                  });
                } else if (postLinkType !== 'none') {
                  let url;

                  if (postLinkType === 'image') {
                    let response;

                    try {
                      const formData = new FormData();
                      formData.append('file', image);
                      response = await (0, _api.default)({
                        method: 'post',
                        url: `/a/forum/upload?participantId=${currentArmParticipantId}`,
                        data: formData
                      });
                      url = `${window.location.protocol}//${window.location.host}/api${response.data.link}`;
                    } catch (err) {
                      console.log(JSON.stringify(err));
                      this.setState({
                        addPostError: true,
                        addPostErrorMessage: 'Image upload failed. Please try again or contact administrator'
                      });
                      return false;
                    }
                  } else {
                    if ((0, _lodash.isEmpty)(videoWebLink)) {
                      this.setState({
                        addPostError: true,
                        addPostErrorMessage: 'Link field cannot be empty'
                      });
                      return false;
                    }

                    if (/^(ftp|http|https):\/\/[^ "]+$/.test(videoWebLink)) {
                      url = videoWebLink;
                    } else {
                      this.setState({
                        addPostError: true,
                        addPostErrorMessage: `The ${postLinkType} link is invalid`
                      });
                      return false;
                    }
                  }

                  Object.assign(newPost, {
                    postLinks: [{
                      type: postLinkType,
                      url
                    }]
                  });
                }

                const post = { ...newPost,
                  topicId: selectedTopicIdsMap.get(currentTopicCollectionId),
                  createdByParticipantId: currentArmParticipantId,
                  studyArmId: currentForum === null || currentForum === void 0 ? void 0 : currentForum.studyArmId
                };
                resetRecentActivityPostIds();
                clearPosts();
                savePost(post);
                this.resetState();
                closeHandler();
              }
            }
          }));
        }
      }
    };

    this.onCancel = () => {
      const {
        closeHandler
      } = this.props;
      const reset = this.resetState.bind(this);
      confirm({
        title: 'Are you sure you want to leave this post?',
        content: 'You will lose all changes.',
        okText: 'Leave',
        okType: 'danger',

        onOk() {
          reset();
          closeHandler();
        },

        onCancel() {}

      });
    };

    this.resetState = () => {
      const resetState = (0, _lodash.cloneDeep)(initialState);
      this.setState(resetState);
    };

    this.handleArmCheckedChange = (checked, id) => {
      const {
        selectedArmIds
      } = this.state;

      if (checked && !selectedArmIds.includes(id)) {
        // Add arm to selectedArmIds
        this.setState({
          selectedArmIds: [...selectedArmIds, id]
        });
      } else if (!checked && selectedArmIds.includes(id)) {
        // Remove arm from selectedArmIds
        this.setState({
          selectedArmIds: [...selectedArmIds.filter(i => i !== id)]
        });
      }
    };

    this.handleTopicIdChange = (topicId, topicCollectionId) => {
      const {
        selectedTopicIdsMap
      } = this.state;
      selectedTopicIdsMap.set(topicCollectionId, topicId);
      this.setState({
        selectedTopicIdsMap
      });
    };

    this.handleAddOptionClick = () => {
      const {
        newPostPollOptions
      } = this.state;
      const updatedNewPostPollOptions = (0, _lodash.clone)(newPostPollOptions);
      updatedNewPostPollOptions.push({
        option: '',
        optionId: (0, _uuid.default)()
      });
      this.setState({
        newPostPollOptions: updatedNewPostPollOptions
      });
    };

    this.handleRemoveOption = index => {
      const {
        newPostPollOptions
      } = this.state;
      const updatedNewPostPollOptions = (0, _lodash.clone)(newPostPollOptions);
      updatedNewPostPollOptions.splice(index, 1);
      this.setState({
        newPostPollOptions: updatedNewPostPollOptions
      });
    };

    this.handleOptionTextChange = (index, value) => {
      if (value === '') {
        this.handleRemoveOption(index);
      } else {
        const {
          newPostPollOptions
        } = this.state;
        newPostPollOptions[index].option = value;
        this.setState({
          newPostPollOptions
        });
      }
    };

    this.handleTitleChange = e => {
      this.setState({
        newPostTitle: e.target.value
      });
    };

    this.handleBodyChange = e => {
      this.setState({
        newPostBody: e.target.value
      });
    };

    this.onPublishDateChange = (value, dateString) => {
      if (value) {
        this.setState({
          newPublishDate: value
        });
      }
    };

    this.handlePostLinkChange = e => {
      this.setState({
        postLinkType: e.target.value
      });
    };

    this.handlePreview = () => {
      this.setState({
        previewVisible: true
      });
    };

    this.handleCancelPreview = () => {
      this.setState({
        previewVisible: false
      });
    };

    this.updateVideoWebLink = e => {
      this.setState({
        videoWebLink: e.target.value
      });
    };

    this.handleSelectedArmParticipantChange = (armId, value) => {
      const selectedParticipantMap = new Map(this.state.selectedParticipantMap);
      selectedParticipantMap.set(armId.toString(), value[0]);
      this.setState({
        selectedParticipantMap
      });
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // if there's only one arm, go ahead and select it
    if (this.props.forums && this.state.selectedArmIds.length !== 1) {
      this.setState({
        selectedArmIds: [this.props.forums[0].studyArmId]
      });
    }
  }

  render() {
    const {
      topics,
      visible,
      forums,
      arms,
      pseudoParticipants,
      hasCareNavigatorRole,
      participants
    } = this.props;
    const {
      fileList,
      newPostPollOptions,
      selectedArmIds,
      selectedTopicIdsMap,
      addPostError,
      addPostErrorMessage,
      postLinkType,
      previewImage,
      previewVisible,
      videoWebLink,
      newPostBody,
      newPostTitle
    } = this.state; // Only display arms that have forums

    const displayedArms = forums ? (0, _lodash.filter)(arms, arm => forums.some(f => f.studyArmId === arm.id)) : []; // Filter by forums linked to selectedArmIds, map forums to topicCollectionIds (number[]), flatten to simple number[]

    const selectedTopicCollectionIds = (0, _lodash.flatten)((0, _lodash.map)((0, _lodash.filter)(forums, f => selectedArmIds.includes(f.studyArmId)), f => f.topicCollectionIds)); // Union topics to remove duplicates

    const displayedTopics = (0, _lodash.filter)(topics, topic => selectedTopicCollectionIds.includes(topic.topicCollectionId)).sort((a, b) => a.title.localeCompare(b.title));
    const displayedTopicsGroupedByArm = (0, _lodash.groupBy)(displayedTopics, t => t.topicCollectionId);

    if (!pseudoParticipants || pseudoParticipants.length === 0 || !pseudoParticipants[0]) {
      return /*#__PURE__*/_react.default.createElement("div", null); // if you have no pseudos then you can't create posts.
    }

    const pseudoParticipantsGroupedByStudyArmId = (0, _lodash.groupBy)((0, _lodash.filter)(pseudoParticipants, p => !!p.username), p => p.studyArmId);
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px'
    };
    const participantSelectorOptions = new Map();

    if (hasCareNavigatorRole) {
      displayedArms.forEach(arm => {
        participantSelectorOptions.set(arm.id.toString(), _lodash.default.map(_lodash.default.filter(participants, p => p.studyArmId === arm.id), participant => {
          return {
            label: participant.username,
            value: participant.id.toString()
          };
        }));
      });
    } else {
      displayedArms.forEach(arm => {
        participantSelectorOptions.set(arm.id.toString(), _lodash.default.map(pseudoParticipantsGroupedByStudyArmId[arm.id.toString()], participant => {
          return {
            label: participant.username,
            value: participant.id.toString()
          };
        }));
      });
    }

    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      className: "addPostModal",
      title: "Add Post",
      width: "45%",
      visible: visible,
      onCancel: this.onCancel,
      onOk: this.handleOk,
      destroyOnClose: true
    }, addPostError && addPostErrorMessage && /*#__PURE__*/_react.default.createElement(_alert.default, {
      message: addPostErrorMessage,
      type: "error",
      showIcon: true
    }), pseudoParticipants && pseudoParticipants.length === 0 && /*#__PURE__*/_react.default.createElement(_alert.default, {
      message: "You have no pseudo participants configured. You cannot create content. Contact an administrator.",
      type: "error",
      showIcon: true
    }), /*#__PURE__*/_react.default.createElement("div", {
      id: "formContainer"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "formRow"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "label"
    }, "Where would you like to post this content?"), /*#__PURE__*/_react.default.createElement("div", {
      id: "studyArmCheckboxes"
    }, displayedArms && displayedArms.length && displayedArms.map(arm => {
      if (hasCareNavigatorRole || pseudoParticipantsGroupedByStudyArmId[arm.id].length > 1) {
        const cascader = /*#__PURE__*/_react.default.createElement("div", null, arm.name, ' ', "(", arm.id, ") as", /*#__PURE__*/_react.default.createElement(_cascader.default, {
          placeholder: "Enter participant's username",
          disabled: !selectedArmIds.includes(arm.id),
          options: participantSelectorOptions.get(arm.id.toString()),
          onChange: v => this.handleSelectedArmParticipantChange(arm.id, v),
          showSearch: {
            filter: selectedParticipantFilter
          }
        }));

        return forums.length === 1 ? cascader : /*#__PURE__*/_react.default.createElement(_checkbox.default, {
          key: `arm-${arm.id}`,
          checked: selectedArmIds.includes(arm.id),
          onChange: e => this.handleArmCheckedChange(e.target.checked, arm.id)
        }, ' ', "cascader");
      }

      const armInfo = `${arm.name} (${pseudoParticipantsGroupedByStudyArmId[arm.id] ? pseudoParticipantsGroupedByStudyArmId[arm.id][0].username : ''})`;
      return forums.length === 1 ? armInfo : /*#__PURE__*/_react.default.createElement(_checkbox.default, {
        key: `arm-${arm.id}`,
        checked: selectedArmIds.includes(arm.id),
        onChange: e => this.handleArmCheckedChange(e.target.checked, arm.id)
      }, armInfo);
    }))), (0, _lodash.map)((0, _lodash.keys)(displayedTopicsGroupedByArm), topicCollectionId => {
      const selectedTopic = topics === null || topics === void 0 ? void 0 : topics.find(t => t.id === selectedTopicIdsMap.get(parseInt(topicCollectionId)));
      const currentArm = (0, _lodash.filter)(displayedArms, arm => {
        const currentForum = forums === null || forums === void 0 ? void 0 : forums.find(f => f.topicCollectionIds.includes(parseInt(topicCollectionId)));
        return arm.id === (currentForum === null || currentForum === void 0 ? void 0 : currentForum.studyArmId);
      })[0];
      return /*#__PURE__*/_react.default.createElement("div", {
        key: `topics-for-${topicCollectionId}`,
        className: "formRow"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "label"
      }, "Topic (", currentArm.name, ")"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_dropdown.default, {
        overlay: /*#__PURE__*/_react.default.createElement(_menu.default, {
          onClick: e => this.handleTopicIdChange(parseInt(e.key), parseInt(topicCollectionId))
        }, (0, _lodash.map)(displayedTopicsGroupedByArm[topicCollectionId], topic => {
          return /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
            key: topic.id
          }, topic.title);
        })),
        placement: "bottomLeft"
      }, /*#__PURE__*/_react.default.createElement(_button.default, null, selectedTopic ? selectedTopic.title : 'Select a topic')));
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "formRow"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "label"
    }, "Publish Date"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_datePicker.default, {
      showTime: true,
      use12Hours: true,
      onChange: this.onPublishDateChange,
      value: this.state.newPublishDate,
      format: "YYYY-MM-DD h:mm a "
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "formRow"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "label"
    }, "Title"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_input.default, {
      className: "input",
      value: newPostTitle,
      placeholder: "Enter poll title",
      onChange: this.handleTitleChange
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "formRow"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "label"
    }, "Body"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(TextArea, {
      style: {
        height: '100px'
      },
      value: newPostBody,
      className: "input",
      placeholder: "Enter poll body",
      onChange: this.handleBodyChange
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "postLinks"
    }, /*#__PURE__*/_react.default.createElement(_radio.default.Group, {
      onChange: e => this.handlePostLinkChange(e),
      value: postLinkType
    }, /*#__PURE__*/_react.default.createElement(_radio.default, {
      key: "none",
      style: radioStyle,
      value: "none"
    }, " None "), /*#__PURE__*/_react.default.createElement(_radio.default, {
      key: "image",
      style: radioStyle,
      value: "image"
    }, " Upload "), /*#__PURE__*/_react.default.createElement(_radio.default, {
      key: "video",
      style: radioStyle,
      value: "video"
    }, " Video "), /*#__PURE__*/_react.default.createElement(_radio.default, {
      key: "web",
      style: radioStyle,
      value: "web"
    }, " Web "), /*#__PURE__*/_react.default.createElement(_radio.default, {
      key: "poll",
      style: radioStyle,
      value: "poll"
    }, " Poll ")), postLinkType === 'image' && /*#__PURE__*/_react.default.createElement("div", {
      className: "upload"
    }, /*#__PURE__*/_react.default.createElement(_upload.default, {
      className: "upload-list-inline",
      beforeUpload: this.beforeUpload,
      onRemove: this.onRemove,
      listType: "picture-card",
      onPreview: this.handlePreview,
      fileList: fileList
    }, fileList.length === 0 && /*#__PURE__*/_react.default.createElement(_button.default, {
      style: {
        whiteSpace: 'pre-wrap'
      }
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fal fa-upload"
    }))), fileList.length === 0 && /*#__PURE__*/_react.default.createElement(_alert.default, {
      message: "Aspect ration should be 3 x 2 and file size should be less than 50k",
      type: "warning"
    }), /*#__PURE__*/_react.default.createElement(_modal.default, {
      visible: previewVisible,
      footer: null,
      onCancel: this.handleCancelPreview
    }, /*#__PURE__*/_react.default.createElement("img", {
      alt: "example",
      style: {
        width: '100%'
      },
      src: previewImage
    }))), postLinkType === 'video' && /*#__PURE__*/_react.default.createElement("div", {
      className: "video"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      className: "video-web-link",
      placeholder: "Must be a valid youtube url like https://youtu.be/...",
      value: videoWebLink,
      onChange: this.updateVideoWebLink
    })), postLinkType === 'web' && /*#__PURE__*/_react.default.createElement("div", {
      className: "video"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      className: "video-web-link",
      placeholder: "Must be a valid web url beginning with http(s)://",
      value: videoWebLink,
      onChange: this.updateVideoWebLink
    })), postLinkType === 'poll' && /*#__PURE__*/_react.default.createElement("div", {
      className: "formRow"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "label"
    }, "Options"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "options-container"
    }, newPostPollOptions.map((option, index) => /*#__PURE__*/_react.default.createElement(_input.default, {
      key: `${option.optionId}`,
      className: "optionInput",
      placeholder: "Enter option text",
      defaultValue: option.option,
      onChange: e => this.handleOptionTextChange(index, e.target.value),
      allowClear: true
    }))), /*#__PURE__*/_react.default.createElement(_button.default, {
      className: "addOptionButton",
      onClick: this.handleAddOptionClick
    }, "Add Option")))));
  }

}

const mapStateToProps = state => {
  return {
    hasCareNavigatorRole: selectors.hasCareNavigatorRole(state),
    topics: selectors.getForumTopics(state),
    arms: selectors.getRequestedStudyStudyArms(state),
    studyId: selectors.getRequestedStudyId(state),
    forums: selectors.getForums(state),
    pseudoParticipants: selectors.getCurrentUserPseudoParticipants(state),
    participants: selectors.getParticipants(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    savePost: newPost => dispatch(_posts.savePostAsync.request(newPost)),
    clearPosts: () => dispatch((0, _posts.clearPosts)()),
    resetRecentActivityPostIds: () => dispatch((0, _forum.resetRecentActivityPostIds)())
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ForumPostCreationModal);

exports.default = _default;